import React from 'react';
import ClipboardListIcon from '@heroicons/react/outline/ClipboardListIcon.js';
import { BlockType } from '../../types/index.js';
import { MainMenuBlock as Component } from './Block.js';
import { mainMenuDefaultItemsFactory } from './constants.js';
import { MainMenuBlockSettings as Settings } from './Settings.js';
export const RegisteredMainMenuBlock = (intl) => {
    const { $t } = intl;
    const mainMenuDefaultItems = mainMenuDefaultItemsFactory(intl);
    return {
        recommendedName: 'MainMenu',
        Component,
        config: {
            type: BlockType.Block,
            displayName: $t({
                id: 'Blocks.MainMenu.DisplayName',
                defaultMessage: 'Main Menu',
            }),
            usable: true,
            Settings,
            Icon: React.createElement(ClipboardListIcon, null),
            defaultProps: {
                items: mainMenuDefaultItems,
            },
        },
    };
};
//# sourceMappingURL=registered.js.map